import React, { memo } from 'react';
import { X } from 'lucide-react';

export interface ActiveFilter {
  fieldKey: string;
  optionValue: string;
}

interface ActiveFiltersProps {
  filters: ActiveFilter[];
  onRemoveFilter: (fieldKey: string, optionValue: string) => void;
  onClearAll: () => void;
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = memo(({ filters, onRemoveFilter, onClearAll }) => {
  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="px-6 w-auto py-3 bg-white border-b border-t border-gray-200 flex items-center gap-3">
      <span className="text-sm text-gray-600 font-medium">Active filters:</span>
      <div className="flex items-center gap-2 flex-wrap">
        {filters.map((filter) => (
          <div
            key={`${filter.fieldKey}-${filter.optionValue}`}
            className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium"
          >
            <span>{filter.optionValue}</span>
            <button
              type="button"
              onClick={() => onRemoveFilter(filter.fieldKey, filter.optionValue)}
              className="hover:bg-blue-200 rounded-full p-0.5 transition-colors"
              aria-label={`Remove ${filter.optionValue} filter`}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={onClearAll}
        className="ml-auto text-sm text-blue-600 hover:text-blue-800 font-medium transition-colors"
      >
        Clear all
      </button>
    </div>
  );
});
